import { api } from './api'

type UploadVisibility = 'private' | 'public'
type UploadFolder = 'artists' | 'musics' | 'events'

export type UploadFileItem = {
  originalName: string
  key: string
  url: string
  contentType: string
  size: number
  kind: 'image' | 'audio'
}

type UploadAssetParams = {
  file: File
  folder: UploadFolder
  title: string
  visibility?: UploadVisibility
}

const slugify = (value: string) =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\.[^/.]+$/, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

export async function uploadAsset({
  file,
  folder,
  title,
  visibility = 'private',
}: UploadAssetParams): Promise<UploadFileItem[]> {
  const formData = new FormData()

  formData.append('files', file)
  formData.append('folder', folder)
  formData.append('slug', slugify(title))
  formData.append('visibility', visibility)

  const response = await api.post('/uploads', formData)

  return response.data.files as UploadFileItem[]
}
